<template>
  <main-template>
    <template v-slot:main>

      <div class="page_top">
        <h1 class="title">
          <span>Мои заказы</span>
        </h1>
      </div>



      <div class="page_content my-orders">

        <div class="top">
          <search-field placeholder="Найти номер заказа"></search-field>
          <dropdown-filed
            c_style="white"
            :current='order_filter.select_counterparty'
            :list='order_filter.counterparties'
            @change="setCounterparty($event)"
          >
          </dropdown-filed>
          <dropdown-filed
            c_style="white"
            :current='order_filter.select_status'
            :list='order_filter.statuses'
            @change="setStatus($event)"
          >
          </dropdown-filed>
        </div>


        <div class="orders-tables">
          <!-- <h3>Товары в наличии</h3> -->
          <orders-table ref="orders_table"></orders-table>
          <!-- <div class="sep"></div> -->
          <!-- <h3>Товаров нет в наличии</h3> -->
          <orders-table ref="na_orders_table" :not_available="true"></orders-table>
        </div>



      </div>


    </template>
  </main-template>
</template>

<script>
import MainTemplate from '@/components/MainTemplate.vue';
import SearchField from "@/components/share/SearchField";
import DropdownFiled from "@/components/share/DropdownField";
import OrdersTable from "@/components/my_orders/OrdersTable";
import axios from "axios";





export default {
  name: 'MyOrdersView',
  components: {
    OrdersTable,
    DropdownFiled,
    SearchField,
    MainTemplate,
  },
  data() {
    return{
      order_filter: {
        select_counterparty: {id: 0, title: "Контрагент (не установлено)"},
        select_status: {id: 0, title: "Статус (не установлено)"},
        counterparties: [],
        statuses: [],
      },
    }
  },
  mounted() {
    this.loadData();
  },
  methods : {
    loadData : async function() {
      let order_id = this.$route.query.q;
      let counterparty_id = this.$route.query.counterparty;
      let status_id = this.$route.query.status;

      let res = await axios.get(
          window.api_url + "order/list"
          +"?order_id="+order_id
          +"&counterparty="+counterparty_id
          +"&status="+status_id
      );

      this.order_filter.counterparties = res.data.data.counterparties;
      this.order_filter.statuses = res.data.data.statuses;

      this.$refs.orders_table.ordersList = res.data.data.orders.avail_list;


      for(let status of this.order_filter.statuses) {
        if(status.id == status_id) {
          this.order_filter.select_status = structuredClone(status);
        }
      }

      for(let counterparty of this.order_filter.counterparties) {
        if(counterparty.id == counterparty_id) {
          this.order_filter.select_counterparty = structuredClone(counterparty);
        }
      }
    },
    setCounterparty : function(counterparty_id) {
      this.$router.push(
          {
            query: {
              q: this.$route.query.q,
              counterparty: counterparty_id,
              status: this.$route.query.status,
            }
          }
      );
    },
    setStatus : function(status_id) {
      this.$router.push(
          {
            query: {
              q: this.$route.query.q,
              counterparty: this.$route.query.counterparty,
              status: status_id,
            }
          }
      );
    }
  },
  watch: {
    '$route.query'() {
      this.loadData();
    }
  }
}
</script>

<style scoped>

.my-orders .top {
  display: flex;
  gap: 20px;
  padding-bottom: 30px;
  margin-bottom: 30px;
  border-bottom: 1px solid var(--Border);
}

.orders-tables h3 {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  margin: 0px 0px 20px 0px;
}

.orders-tables .sep{
  width: 100%;
  height: 1px;
  background: var(--Border);
  margin: 30px 0px;
}



/*MOBILE*/
@media (max-width: 1250px)
{
  .my-orders .top {
    flex-direction: column;
    gap: 8px;
    padding-bottom: 20px;
  }
}
</style>



<style>

.my-orders .top .search-product {
  width: 544px;
  margin: 0px;
}



/*MOBILE*/
@media (max-width: 1250px)
{
  .my-orders .top .search-product {
    width: 100%;
    height: 44px;
  }

  .my-orders .top .search-product .search-field button {
    display: none;
  }

  .my-orders .top .dropdown_field .input_area input{
    height: 44px;
    padding: 13px 18px;
  }

  .my-orders .top .dropdown_field .dd_icon {
    top: 12px;
  }
}

</style>
